module.exports = __webpack_public_path__ + "img/icons-40-perks-personal-growth.c709d51e.svg";